<script>
import Layout from "@/router/layouts/main";
import Stat from "@/components/widgets/stat";
import { api } from "@/state/services";

export default {
  components: {
    Layout,
    Stat,
  },
  data() {
    return {
      balances: [],

      fields: [
        { key: "date", label: "Data" },
        { key: "product", label: "Produto" },
        { key: "description", label: "Descrição" },
        { key: "value", label: "Valor" },
      ],

      total: 0,
      currentPage: "1",
      perPage: "25",

      extract: null,
    };
  },
  methods: {
    getExtract() {
      this.extract = null;

      api
        .get("saas/extract")
        .then((response) => {
          if (response.data.status == "success") {
            this.balances = response.data.balances;
            this.extract = response.data.extract;
          }
        })
        .catch((error) => {
          if (error) {
            this.balances = [];
            this.extract = [];
          }
        })
    },
  },
  mounted() {
    this.getExtract();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Produtos</li>
      <li class="breadcrumb-item d-none d-sm-block">Extrato</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Extrato</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div v-for="(stat, index) of balances" :key="index" class="col-6 col-md-3">
        <Stat type="line" icon="bx-cog" :title="stat.name" :value="stat.total" />
      </div>
    </div>

    <div id="dropdown" class="d-none mb-4">
      <b-dropdown variant="outline-light">
        <template #button-content>
          ações
          <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
          </svg>
        </template>
        <b-dropdown-item v-on:click="showActivate();">Ativar</b-dropdown-item>
      </b-dropdown>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="min-vh-25 text-center d-flex justify-content-center align-items-center" v-if="!extract">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>

        <div v-else-if="extract && extract.length == 0" class="min-vh-25 text-center d-flex justify-content-center align-items-center">
          <div>
            <i class="far fa-sad-cry font-size-24"></i><br>
            nenhum registro encontrado
          </div>
        </div>

        <div v-else class="table-responsive">
          <b-table :items="extract" :fields="fields" class="table-nowrap table-style table-hover table-pointer min-vh-25" head-variant="light" :current-page="currentPage" :per-page="perPage" responsive>
            <template #cell(actions)="row">
              <div v-if="row">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
                  <path d="M12 9a3.02 3.02 0 0 0-3 3c0 1.642 1.358 3 3 3 1.641 0 3-1.358 3-3 0-1.641-1.359-3-3-3z"></path>
                  <path
                    d="M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 12c-5.351 0-7.424-3.846-7.926-5C4.578 10.842 6.652 7 12 7c5.351 0 7.424 3.846 7.926 5-.504 1.158-2.578 5-7.926 5z">
                  </path>
                </svg>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </Layout>
</template>